import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { BaseGetProvider, BasePostProvider, DataTransformationProtocol } from "@tendercuts/http";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { StoreConfig } from "@tendercuts/models";

@Injectable({providedIn: "root"})
export class StoreConfigService extends BaseGetProvider<StoreConfig> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
    this.delegate = this;
  }

  // override this
  preProcessResponse(response) {
    return response.results;
  }

  get isCachable() {
    return true;
  }

  get isAuthenticatedEndpoint() {
    return false;
  }

  get authProtocol() {
    return this.loginService;
  }

  get model() {
    return StoreConfig;
  }

  get endpoint() {
    return this.endpointService.getStoreConfig();
  }

  getParams(storeId: String) {
    let params = {
        store_id: storeId,
    } 
    return params;
  }
}
